<template>
  <nav aria-label="breadcrumb" class="breadcrumb-nav">
    <ol class="breadcrumb NKT-P2">
      <li class="breadcrumb-item mb-1">
        <RouterLink to="/" :class="{ header: route.name !== 'home' }">Home</RouterLink>
      </li>

      <li
        v-for="(route, index) in currentRouteName"
        :key="index"
        v-on:click="goTo(route.displayLink)"
        class="breadcrumb-item mb-1"
        :class="[
          ,
          { active: index === currentRouteName.length - 1 },
          { link: route.displayLink !== null }
        ]"
      >
        {{
          route.displayName
            ? route.displayName
            : breadcrumbStore.link
            ? breadcrumbStore.link
            : route.name
        }}
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { useBreadcrumbStore } from '@/stores/BreadcrumbStore'
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const breadcrumbStore = useBreadcrumbStore()

const currentRouteName = ref()

watch(
  () => route.meta.breadcrumbs,
  (newVal) => {
    currentRouteName.value = newVal
  },
  { immediate: true }
)

const goTo = (link: string | null) => {
  if (link) {
    router.push({ path: link })
  }
}
</script>

<style scoped>
.breadcrumb-item {
  color: #26316e;
  transition: color 300ms ease-out;
}
.breadcrumb-item.active {
  font-weight: 500;
}

.breadcrumb-item.link {
  cursor: pointer;
}

.breadcrumb-item .header {
  transition: color 300ms ease-out;
}

.breadcrumb-item .header:hover,
.breadcrumb-item.link:hover {
  color: #06a3da;
}
</style>
